// test1138
(1138 && 0);
